var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashbordIconCertificates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.973,
    height: 33.85,
    viewBox: "0 0 26.973 33.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "certificates",
    d: "M73.165,14.809a5.818,5.818,0,1,0,5.818,5.818A5.825,5.825,0,0,0,73.165,14.809Zm2.467,4.884-2.116,3.173a1.058,1.058,0,0,1-1.467.293L70.463,22.1a1.058,1.058,0,0,1,1.174-1.76l.706.471c1.687-2.53,1.6-2.46,1.88-2.622A1.058,1.058,0,0,1,75.632,19.693Zm-7.227,7.276v5.822a1.058,1.058,0,0,0,1.583.918l3.177-1.815,3.177,1.815a1.058,1.058,0,0,0,1.583-.918V26.969A7.914,7.914,0,0,1,68.405,26.969ZM75.281,12.98V2.3a2.3,2.3,0,0,0-2.3-2.3H54.307a2.3,2.3,0,0,0-2.3,2.3V26.791a2.3,2.3,0,0,0,2.3,2.3H66.29c0-4.552-.007-4.27.017-4.48A7.941,7.941,0,0,1,75.281,12.98ZM58.357,5.289h8.991a1.058,1.058,0,0,1,0,2.116H58.357a1.058,1.058,0,0,1,0-2.116Zm5.289,10.578H58.357a1.058,1.058,0,0,1,0-2.116h5.289a1.058,1.058,0,1,1,0,2.116Zm-5.289-4.231a1.058,1.058,0,0,1,0-2.116h8.991a1.058,1.058,0,0,1,0,2.116Z",
    transform: "translate(-52.01)",
    fill: "#5eba79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashbordIconCertificates);
export default __webpack_public_path__ + "static/media/dashbord-icon-certificates.5fb61abe2f4e47a09449155b58f7332b.svg";
export { ForwardRef as ReactComponent };